import React from "react";
import Modal from "react-bootstrap/Modal";
import SoftwareSolutionWidget from "../../../../widget/software-solution-with-details";
import { ReactComponent as Loader } from "../../../../../resources/images/Rolling.svg";
import Button from "react-bootstrap/Button";
import IndustryWidget from "../../../../widget/industries-list";

type IpropsModal = {
    dataSource: any;
};

export default function ModalEditSolution(props : IpropsModal){
    return(
        <Modal
            show={props?.dataSource?.industryShow}
            onHide={() => props?.dataSource?.cancelChange()}
            className="modalDevinsider large"
        >
            <Modal.Header closeButton>
                <Modal.Title>Targeted industry</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>What industry do you target with your software solution(s)? Select all that apply</div>
                <IndustryWidget
                    {...props?.dataSource?.UseTargetedIndustry}
                />
            </Modal.Body>  
            <Modal.Footer>
                <Button
                    className="cancelbtn"
                    onClick={() => props?.dataSource?.cancelChange()}
                >
                Cancel
                </Button>
                <Button
                    className="validate"
                    onClick={() => props?.dataSource?.updateCompanyResellerDetails("industry")}
                    disabled={props?.dataSource?.isLoaderShow}
                >
                {props?.dataSource?.isLoaderShow ? <Loader /> : "Save"}
                </Button> 
            </Modal.Footer>  
        </Modal>
    );
}